import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e421b40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "a-auth full-height" }
const _hoisted_2 = { class: "ion-text-center full-height profile-wrapper profile" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "mb-35" }, "Profile", -1))
const _hoisted_4 = { class: "m-width" }
const _hoisted_5 = { class: "username" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "small-divider" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ion-padding desc-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Deleting user profile is irreversible action.")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "All user data will be deleted!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "This action cannot be reverted and all user data will be deleted. You will lose your collection with no option to restore it."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("If you need assistence regarding your user account, contact "),
    /*#__PURE__*/_createElementVNode("u", null, [
      /*#__PURE__*/_createElementVNode("a", { href: "mailto: adminAOPC@aicolympic.org" }, "adminAOPC@aicolympic.org")
    ])
  ])
], -1))
const _hoisted_8 = { class: "ion-padding-horizontal profile-bottom-wrapper" }
const _hoisted_9 = { class: "ion-padding-top version" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createElementVNode("p", null, _toDisplayString(_ctx.user.username), 1),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.user.email), 1),
              _hoisted_6
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ion_button, {
              class: "--default --danger-outline",
              expand: "block",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.deleteProfileConfirm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Confirm delete profile")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_9, "App version: " + _toDisplayString($data.version), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}